/* ----------------- CUSTOM SCRIPTS - RICK ----------------- */

// ============================================
// FOOTER FORM SEND TO KLAVIYO FLOW
// ============================================

document.addEventListener("DOMContentLoaded", function() {
  const form = document.querySelector(".site_footer__form");
  if (!form) return;

  // Klaviyo configuratie
  const KLAVIYO_PUBLIC_KEY = "XsVQcW";
  const KLAVIYO_LIST_ID = "TaFi88";

  // Submit handler
  form.addEventListener("submit", async function(event) {
    event.preventDefault(); // Voorkom dat de pagina herlaadt

    const submitButton = form.querySelector(".site_footer__submit");
    const originalText = submitButton.textContent;

    // Haal de waardes op uit het formulier
    const firstName = form.querySelector('input[name="firstname"]').value.trim();
    const lastName = form.querySelector('input[name="lastname"]').value.trim();
    const email = form.querySelector('input[name="email"]').value.trim();

    // Basisvalidatie
    if (!email || !email.includes("@")) {
      showFeedback("Voer een geldig e-mailadres in.", "error");
      return;
    }

    // UI feedback: button "loading" state
    submitButton.textContent = "Bezig met verzenden...";
    submitButton.disabled = true;

    try {
      const response = await fetch(
        `https://a.klaviyo.com/client/subscriptions/?company_id=${KLAVIYO_PUBLIC_KEY}`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "revision": "2024-10-15"
          },
          body: JSON.stringify({
            data: {
              type: "subscription",
              attributes: {
                profile: {
                  data: {
                    type: "profile",
                    attributes: {
                      email: email,
                      first_name: firstName || null,
                      last_name: lastName || null,
                      properties: {
                        source: "Footer newsletter signup"
                      }
                    }
                  }
                },
                custom_source: "Website footer"
              },
              relationships: {
                list: {
                  data: {
                    type: "list",
                    id: KLAVIYO_LIST_ID
                  }
                }
              }
            }
          })
        }
      );

		if (response.ok || response.status === 202) {
		  showFeedback("Bedankt voor je aanmelding! Kijk even in je inbox voor je kortingscode van €5", "success");
		  form.style.display = "none";  // verberg het formulier
      } else {
        const errorData = await response.json().catch(() => ({}));
        console.error("Klaviyo error:", errorData);
        showFeedback("Er is een fout opgetreden. Probeer het nog eens.", "error");
      }

    } catch (error) {
      console.error("Network error:", error);
      showFeedback("Verbindingsfout. Probeer het nog eens.", "error");

    } finally {
      // Reset button state
      submitButton.textContent = originalText;
      submitButton.disabled = false;
    }
  });

	// Feedback messages tonen
	function showFeedback(message, type) {
	  // Verwijder eventuele oude feedback
	  const existing = form.parentElement.querySelector(".site_footer__feedback");
	  if (existing) existing.remove();

	  // Nieuwe feedback toevoegen
	  const feedback = document.createElement("p");
	  feedback.className = `site_footer__feedback site_footer__feedback--${type}`;
	  feedback.textContent = message;
	  form.insertAdjacentElement("afterend", feedback);

	  // Alleen error-meldingen automatisch verbergen, succes blijft staan
	  if (type === "error") {
		setTimeout(() => {
		  feedback.style.opacity = "0";
		  setTimeout(() => feedback.remove(), 400);
		}, 6000);
	  }
	}
});

// ============================================
// FADE-IN ANIMATION
// ============================================

document.addEventListener("DOMContentLoaded", function() {
    const fadeSections = document.querySelectorAll(".fade-in-section");

    const observer = new IntersectionObserver((entries, observer) => {
    entries.forEach(entry => {
        if (entry.isIntersecting) {
        entry.target.classList.add("is-visible");
        observer.unobserve(entry.target); // Zorgt dat het niet opnieuw triggert
        }
    });
    }, {
    threshold: 0.4 // 40% zichtbaar voordat animatie start
    });

    fadeSections.forEach(section => {
    observer.observe(section);
    });
});

// ============================================
// NUMBERS COUNTING UP ANIMATION
// ============================================

document.addEventListener("DOMContentLoaded", function() {
  const numbers = document.querySelectorAll(".stats_section__number");

  // Easing-functie: snel start, zacht aflopen
  // (ease-out cubic — voelt premium)
  function easeOutCubic(t) {
    return 1 - Math.pow(1 - t, 3);
  }

  function animateCount(element) {
    const target = parseFloat(element.dataset.target);
    const suffix = element.dataset.suffix || "";
    const duration = 1800; // ms — verlaag voor sneller, verhoog voor langzamer
    const startTime = performance.now();

    function update(currentTime) {
      const elapsed = currentTime - startTime;
      const progress = Math.min(elapsed / duration, 1);
      const eased = easeOutCubic(progress);
      const currentValue = Math.round(target * eased);

      element.textContent = currentValue + suffix;

      if (progress < 1) {
        requestAnimationFrame(update);
      } else {
        element.textContent = target + suffix; // verzeker eindwaarde
      }
    }

    requestAnimationFrame(update);
  }

  // IntersectionObserver — start tellen wanneer zichtbaar
  const observer = new IntersectionObserver((entries, obs) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        animateCount(entry.target);
        obs.unobserve(entry.target); // animatie eenmalig per laad-sessie
      }
    });
  }, {
    threshold: 0.5 // start als 50% zichtbaar is
  });

  numbers.forEach(num => observer.observe(num));
});

// ============================================
// CUSTOM CONTACT FORM SEND MAIL TO support@loevcosmetics.com
// ============================================

document.addEventListener("DOMContentLoaded", function() {
  const form = document.querySelector(".contact_form__form");
  if (!form) return;

  form.addEventListener("submit", async function(event) {
    event.preventDefault();

    const submitButton = form.querySelector(".contact_form__submit");
    const originalText = submitButton.textContent;

    // UI feedback
    submitButton.textContent = "Sending...";
    submitButton.disabled = true;

    try {
      const formData = new FormData(form);

      const response = await fetch(form.action, {
        method: "POST",
        body: formData,
        headers: { "Accept": "application/json" }
      });

      const result = await response.json();

      if (result.success) {
        showFeedback("Bedankt voor je bericht! We nemen binnen 24 uur contact met je op.", "success");
        form.reset();
      } else {
        console.error("Web3Forms error:", result);
        showFeedback("Er is een fout opgetreden. Probeer het nog eens of stuur ons direct een e-mail.", "error");
      }

    } catch (error) {
      console.error("Network error:", error);
      showFeedback("Verbindingsfout. Probeer het nog eens.", "error");

    } finally {
      submitButton.textContent = originalText;
      submitButton.disabled = false;
    }
  });

  function showFeedback(message, type) {
    const existing = form.parentElement.querySelector(".contact_form__feedback");
    if (existing) existing.remove();

    const feedback = document.createElement("p");
    feedback.className = `contact_form__feedback contact_form__feedback--${type}`;
    feedback.textContent = message;
    form.insertAdjacentElement("afterend", feedback);

    // Alleen error-meldingen verdwijnen, succes blijft
    if (type === "error") {
      setTimeout(() => {
        feedback.style.opacity = "0";
        setTimeout(() => feedback.remove(), 400);
      }, 6000);
    }
  }
});

// ============================================
// BEFORE / AFTER COMPARE SLIDERS
// ============================================
document.addEventListener("DOMContentLoaded", function() {
  const sliders = document.querySelectorAll("[data-compare]");

  sliders.forEach(slider => {
    const beforeWrap = slider.querySelector(".before_after__before-wrap");
    const handle = slider.querySelector("[data-compare-handle]");
    if (!beforeWrap || !handle) return;

    let isDragging = false;
    let touchStartX = 0;
    let touchStartY = 0;
    let dragDirection = null; // 'horizontal' | 'vertical' | null

    // Bereken percentage op basis van muis/touch positie
    function updatePosition(clientX) {
      const rect = slider.getBoundingClientRect();
      let x = clientX - rect.left;
      
      x = Math.max(0, Math.min(x, rect.width));
      const percent = (x / rect.width) * 100;

      beforeWrap.style.clipPath = `inset(0 ${100 - percent}% 0 0)`;
      handle.style.left = `${percent}%`;
    }

    // ----- Mouse handlers (desktop) -----
    function onMouseDown(event) {
      isDragging = true;
      slider.style.cursor = "grabbing";
      updatePosition(event.clientX);
      event.preventDefault();
    }

    function onMouseMove(event) {
      if (!isDragging) return;
      updatePosition(event.clientX);
    }

    function onMouseUp() {
      isDragging = false;
      slider.style.cursor = "ew-resize";
    }

    // ----- Touch handlers (mobiel) -----
    function onTouchStart(event) {
      touchStartX = event.touches[0].clientX;
      touchStartY = event.touches[0].clientY;
      dragDirection = null;
      isDragging = true;
      // GEEN preventDefault hier — we weten nog niet of het horizontaal of verticaal is
    }

    function onTouchMove(event) {
      if (!isDragging) return;

      const currentX = event.touches[0].clientX;
      const currentY = event.touches[0].clientY;
      const deltaX = Math.abs(currentX - touchStartX);
      const deltaY = Math.abs(currentY - touchStartY);

      // Bepaal de intentie van de gebruiker op basis van eerste beweging
      if (dragDirection === null) {
        if (deltaX > 10 || deltaY > 10) {
          dragDirection = deltaX > deltaY ? 'horizontal' : 'vertical';
        }
      }

      // Alleen ingrijpen als gebruiker horizontaal veegt
      if (dragDirection === 'horizontal') {
        updatePosition(currentX);
        event.preventDefault();
      }
      // Bij verticale beweging: laat de pagina normaal scrollen
    }

    function onTouchEnd() {
      isDragging = false;
      dragDirection = null;
    }

    // ----- Event listeners -----
    // Mouse
    slider.addEventListener("mousedown", onMouseDown);
    window.addEventListener("mousemove", onMouseMove);
    window.addEventListener("mouseup", onMouseUp);

    // Touch
    slider.addEventListener("touchstart", onTouchStart, { passive: true });
    slider.addEventListener("touchmove", onTouchMove, { passive: false });
    slider.addEventListener("touchend", onTouchEnd);
  });
});

// ============================================
// SECTION STORE FORM GOES IN KLAVIYO FLOW
// ============================================
(function() {
  var processedForms = new WeakSet();
  
  document.addEventListener('submit', function(e) {
    var form = e.target;
    
    var isPopupForm = form.className && form.className.indexOf('modal-popup') !== -1;
    if (!isPopupForm) return;
    
    // Voorkom oneindige lus
    if (processedForms.has(form)) return;

    var emailInput = form.querySelector('input[type="email"], input[name="contact[email]"]');
    if (!emailInput || !emailInput.value) return;

    // Stop deze submit, doe Klaviyo call, en submit dan opnieuw
    e.preventDefault();
    e.stopPropagation();
    
    var email = emailInput.value;
    processedForms.add(form);

    fetch('https://a.klaviyo.com/client/subscriptions/?company_id=XsVQcW', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'revision': '2024-10-15'
      },
      body: JSON.stringify({
        data: {
          type: 'subscription',
          attributes: {
            custom_source: 'Section Store Popup',
            profile: {
              data: {
                type: 'profile',
                attributes: {
                  email: email
                }
              }
            }
          },
          relationships: {
            list: { 
              data: { 
                type: 'list', 
                id: 'TaFi88' 
              } 
            }
          }
        }
      })
    }).then(function() {
      // Klaaviyo is klaar — laat Section Store nu zijn eigen flow doen
      form.submit();
    }).catch(function(err) { 
      console.error('Klaviyo error:', err);
      // Ook bij fout: laat Section Store zijn ding doen zodat de gebruiker niet vastloopt
      form.submit();
    });
  }, true);
})();

// ============================================
// STICKY BUY BUTTON — toon pas onder de hoofd-CTA
// ============================================
document.addEventListener("DOMContentLoaded", function() {
  const stickyBuy = document.querySelector(".wt-product__sticky-buy");
  
  // Hoofd-add-to-cart knop in jouw theme (Kaching Bundles + custom theme)
  const mainAddToCart = document.querySelector(".wt-product__add-to-cart_form--wrapper");

  if (!stickyBuy) {
    console.warn("Sticky buy element niet gevonden");
    return;
  }
  if (!mainAddToCart) {
    console.warn("Hoofd add-to-cart niet gevonden");
    return;
  }

  console.log("Sticky buy logic actief op:", mainAddToCart);

  // Verberg de sticky buy initieel
  stickyBuy.classList.remove("wt-product__sticky-buy--show");

  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        // Hoofd-CTA is zichtbaar → verberg sticky
        stickyBuy.classList.remove("wt-product__sticky-buy--show");
      } else {
        // Hoofd-CTA uit beeld → check positie
        const rect = mainAddToCart.getBoundingClientRect();
        if (rect.bottom < 0) {
          // Knop is boven het scherm uit gescrold → toon sticky
          stickyBuy.classList.add("wt-product__sticky-buy--show");
        } else {
          // Knop is nog onder het scherm → verberg sticky
          stickyBuy.classList.remove("wt-product__sticky-buy--show");
        }
      }
    });
  }, {
    threshold: 0,
    rootMargin: "0px"
  });

  observer.observe(mainAddToCart);
});

// ============================================
// CART — Tel "van prijzen" op uit Kaching line items
// ============================================
(function() {
  // Parse "€34,95 EUR" naar getal in cents (3495)
  function parsePrice(text) {
    if (!text) return 0;
    // Verwijder valutatekens, spaties, "EUR"
    let clean = text.replace(/[^\d,.-]/g, '').trim();
    // Nederlandse notatie: punt = duizendtal, komma = decimaal
    // Bv "1.234,95" → eerst punten weg, dan komma naar punt
    clean = clean.replace(/\./g, '').replace(',', '.');
    const num = parseFloat(clean);
    if (isNaN(num)) return 0;
    return Math.round(num * 100); // cents
  }

  // Format cents terug naar "€49,86 EUR"
  function formatPrice(cents) {
    const euros = (cents / 100).toFixed(2).replace('.', ',');
    return `€${euros} EUR`;
  }

  // Hoofdfunctie: tel oude prijzen op
  function updateFromTotal() {
    const oldPrices = document.querySelectorAll('.cart-item__old-price');
    if (!oldPrices.length) return;

    let totalCents = 0;
    oldPrices.forEach(el => {
      totalCents += parsePrice(el.textContent);
    });

    // Vul de subtotal "from-price" in
    const target = document.querySelector('[data-from-total] s');
    if (target) {
      target.textContent = formatPrice(totalCents);
    }
  }

  // Eerste keer: zodra DOM klaar is
  document.addEventListener('DOMContentLoaded', updateFromTotal);

  // Daarna: telkens als de cart verandert
  // Shopify dispatches verschillende events afhankelijk van theme
  document.addEventListener('cart:updated', updateFromTotal);
  document.addEventListener('cart:refresh', updateFromTotal);
  document.addEventListener('cart:change', updateFromTotal);

  // Vangnet: observeer wijzigingen in de cart drawer DOM
  // Dit dekt alle cases waar Shopify/Kaching de cart HTML vervangt
  const cartDrawer = document.querySelector('.wt-cart__drawer, cart-drawer, #CartDrawer');
  if (cartDrawer) {
    const observer = new MutationObserver(() => {
      // Throttle: alleen runnen na korte pauze om performance te sparen
      clearTimeout(window._cartUpdateTimeout);
      window._cartUpdateTimeout = setTimeout(updateFromTotal, 100);
    });
    observer.observe(cartDrawer, { childList: true, subtree: true });
  }
})();

// ============================================
// CUSTOM STICKY ATC
// ============================================
document.addEventListener("DOMContentLoaded", function() {
  const customSticky = document.querySelector("[data-custom-sticky]");
  const mainAddToCart = document.querySelector(".js-add-to-cart");
  const scrollButton = document.querySelector("[data-scroll-to-bundles]");

  if (!customSticky) return;
  if (!mainAddToCart) return;

  // ============================================
  // Show/hide logic: alleen tonen wanneer hoofd-ATC uit beeld is
  // ============================================
  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        customSticky.classList.remove("is-visible");
      } else {
        const rect = mainAddToCart.getBoundingClientRect();
        if (rect.bottom < 0) {
          customSticky.classList.add("is-visible");
        } else {
          customSticky.classList.remove("is-visible");
        }
      }
    });
  }, {
    threshold: 0,
    rootMargin: "0px"
  });

  observer.observe(mainAddToCart);

  // ============================================
  // Scroll naar Kaching bundels
  // ============================================
  if (scrollButton) {
    scrollButton.addEventListener("click", function() {
      const target = document.querySelector(".kaching-bundles");
      if (target) {
        target.scrollIntoView({ behavior: "smooth", block: "start" });
      }
    });
  }
});

// ============================================
// DERMATOLOGEN BAR — overlay op eerste product-slide
// ============================================
document.addEventListener("DOMContentLoaded", function() {
  const firstSlide = document.querySelector(".swiper-wrapper .swiper-slide:first-child");
  
  if (!firstSlide) return;
  if (firstSlide.querySelector(".dermatologen_bar")) return;

  // Maak de overlay als <div> in plaats van <a>
  const overlay = document.createElement("div");
  overlay.className = "dermatologen_bar";
  overlay.setAttribute("role", "button");
  overlay.setAttribute("tabindex", "0");
  overlay.setAttribute("aria-label", "Bekijk onze experts");
  overlay.innerHTML = `
    <img src="https://cdn.shopify.com/s/files/1/0926/4264/0200/files/Dermatologen-bar.png?v=1785336019" 
         alt="40+ dermatologen achter deze formule">
  `;

  // Klik-handler
  function scrollToExperts(event) {
    event.preventDefault();
    event.stopPropagation();
    const target = document.querySelector("#experts_section");
    if (target) {
      target.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  }

  overlay.addEventListener("click", scrollToExperts);
  
  // Keyboard support (Enter of Space)
  overlay.addEventListener("keydown", function(event) {
    if (event.key === "Enter" || event.key === " ") {
      scrollToExperts(event);
    }
  });

  // Plaats overlay in de slide zelf (buiten de bestaande anchor)
  firstSlide.appendChild(overlay);
});

// ============================================
// EMERGENCY FIX — verwijder stuck overlays bij cart open
// ============================================
(function() {
  function cleanupStuckOverlays() {
    // Vind alle fixed elements die groot zijn en witte achtergrond hebben
    const suspects = document.querySelectorAll('*');
    suspects.forEach(el => {
      const s = getComputedStyle(el);
      const rect = el.getBoundingClientRect();
      
      // Skip de cart-drawer zelf en de backdrop
      if (el.closest('cart-drawer')) return;
      if (el.classList.contains('wt-cart__drawer')) return;
      if (el.classList.contains('page-overlay-cart')) return;
      if (el.id === 'CartDrawer') return;
      
      // Detecteer verdachte witte fullscreen overlays
      const isWhite = s.backgroundColor === 'rgb(255, 255, 255)' || 
                      s.backgroundColor === 'rgba(255, 255, 255, 1)';
      const isFullscreen = rect.width >= window.innerWidth * 0.8 && 
                          rect.height >= window.innerHeight * 0.5;
      const isFixed = s.position === 'fixed';
      const isVisible = s.opacity !== '0' && s.visibility !== 'hidden';
      
      if (isWhite && isFullscreen && isFixed && isVisible) {
        console.warn('Stuck overlay verborgen:', el);
        el.style.display = 'none';
      }
    });
  }

  // Watch body class changes — cart-drawer open state
  const observer = new MutationObserver((mutations) => {
    mutations.forEach(m => {
      if (m.type === 'attributes' && m.attributeName === 'class') {
        if (document.body.classList.contains('page-overlay-cart-on')) {
          // Cart opent — wacht even en ruim op
          setTimeout(cleanupStuckOverlays, 100);
          setTimeout(cleanupStuckOverlays, 300);
          setTimeout(cleanupStuckOverlays, 600);
        }
      }
    });
  });

  observer.observe(document.body, { attributes: true, attributeFilter: ['class'] });
})();